(() => {
  const scrollKey = (url = window.location.href) => `rogueleker:scroll:${new URL(url, window.location.origin).pathname}${new URL(url, window.location.origin).search}`;
  const scrollTarget = () => document.querySelector('.page-wrapper') || document.scrollingElement;

  const saveScroll = () => {
    try { sessionStorage.setItem(scrollKey(), String(Math.round(scrollTarget()?.scrollTop || 0))); } catch (_) {}
  };

  const restoreInteraction = () => {
    document.documentElement.classList.remove('is-transitioning', 'page-transitioning');
    document.body.classList.remove('is-transitioning', 'page-transitioning');
    document.documentElement.classList.remove('scroll-lock', 'overflow-hidden');
    document.body.classList.remove('scroll-lock', 'overflow-hidden');
    document.documentElement.style.pointerEvents = '';
    document.body.style.pointerEvents = '';
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    const main = document.querySelector('#MainContent');
    const surface = document.querySelector('.page-wrapper');
    if (main) {
      main.removeAttribute('inert');
      main.removeAttribute('aria-hidden');
      main.style.pointerEvents = '';
    }
    if (surface) {
      surface.removeAttribute('inert');
      surface.removeAttribute('aria-hidden');
      surface.style.pointerEvents = '';
      surface.style.touchAction = '';
    }
    document.querySelectorAll('#header-component details[open]').forEach((details) => details.removeAttribute('open'));
    document.querySelectorAll('dialog[open]').forEach((dialog) => {
      try { dialog.close(); } catch (_) { dialog.removeAttribute('open'); }
    });
  };

  const focusInteractionSurface = () => {
    if (document.activeElement !== document.body && document.activeElement !== document.documentElement) return;
    const main = document.querySelector('#MainContent');
    if (!main) return;
    if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
    try { main.focus({ preventScroll: true }); } catch (_) {}
  };

  const queueInteractionRestore = () => {
    const run = () => {
      restoreInteraction();
      resetSubmittingForms();
      focusInteractionSurface();
    };
    run();
    requestAnimationFrame(() => requestAnimationFrame(run));
    window.setTimeout(run, 140);
    window.setTimeout(run, 420);
  };

  const restoreScroll = () => {
    const nav = performance.getEntriesByType('navigation')[0];
    if (!nav || nav.type !== 'back_forward' || window.location.hash) return;
    let stored;
    try { stored = sessionStorage.getItem(scrollKey()); } catch (_) { return; }
    if (stored === null) return;
    const top = Number(stored);
    requestAnimationFrame(() => requestAnimationFrame(() => scrollTarget()?.scrollTo({ top, left: 0, behavior: 'auto' })));
  };

  const cleanProductCopy = (root = document) => {
    if (document.body.dataset.templateType !== 'product') return;
    const scope = root.querySelector?.('.product-information') || document.querySelector('.product-information');
    if (!scope) return;
    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      node.nodeValue = node.nodeValue
        .replace(/una selección de 1\s*kg de piezas/gi, 'una selección de piezas')
        .replace(/cada kilo de piezas/gi, 'cada selección de piezas')
        .replace(/a selection of 1\s*kg of pieces/gi, 'a selection of pieces')
        .replace(/each kilo of pieces/gi, 'each selection of pieces');
    });
    scope.querySelectorAll('strong').forEach((element) => {
      if (/^1\s*kg de piezas lego® originales$/i.test(element.textContent.trim())) element.textContent = 'piezas LEGO® originales';
    });
    scope.querySelectorAll('li').forEach((element) => {
      if (/^1\s*kg total por unidad$/i.test(element.textContent.trim())) element.remove();
    });
  };

  const improveSearch = () => {
    document.querySelectorAll('input[type="search"]').forEach((input) => {
      input.setAttribute('spellcheck', 'true');
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('enterkeyhint', 'search');
    });
  };

  const formatWholeMoney = (root = document) => {
    if (/\/checkouts?(?:\/|$)/.test(window.location.pathname)) return;
    const scope = root.nodeType === Node.TEXT_NODE ? root.parentElement : root;
    if (!scope) return;
    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !/[,.]00/.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        if (node.parentElement?.closest('script,style,noscript,textarea')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      node.nodeValue = node.nodeValue
        .replace(/(\d[\d.\s\u00a0]*)[,.]00(\s*(?:€|EUR))/g, '$1$2')
        .replace(/((?:€|EUR)\s*\d[\d.\s\u00a0]*)[,.]00\b/g, '$1');
    });
  };

  const resetSubmittingForms = () => {
    document.querySelectorAll('button[data-rog-submitting="true"]').forEach((button) => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.removeAttribute('data-rog-submitting');
      if (button.dataset.originalLabel) button.innerHTML = button.dataset.originalLabel;
    });
  };

  const enhanceContactForms = () => {
    document.querySelectorAll('form[action*="contact"]').forEach((form) => {
      if (form.dataset.rogEnhanced === 'true') return;
      form.dataset.rogEnhanced = 'true';
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        const button = form.querySelector('button[type="submit"]');
        if (!button) return;
        button.dataset.originalLabel = button.innerHTML;
        button.dataset.rogSubmitting = 'true';
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
        button.textContent = button.dataset.submittingLabel || '…';
      });
    });

    const success = document.querySelector('[data-form-success]:not([data-rog-announced])');
    if (!success) return;
    success.dataset.rogAnnounced = 'true';
    window.setTimeout(() => {
      success.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      try { success.focus({ preventScroll: true }); } catch (_) {}
    }, 320);
  };

  const searchTerms = [
    { terms: ['ninjago'], label: 'LEGO® Ninjago', url: '/collections/ninjago' },
    { terms: ['star wars'], label: 'LEGO® Star Wars', url: '/collections/star-wars' },
    { terms: ['technic'], label: 'LEGO® Technic', url: '/products/lego%C2%AE-technic' },
    { terms: ['estandar', 'standard'], label: 'LEGO® Estándar', url: '/collections/estandar' },
    { terms: ['bloques', 'blocks'], label: 'LEGO® Bloques', url: '/collections/bloques' },
    { terms: ['colores', 'colors'], label: 'LEGO® Colores', url: '/collections/colores' },
    { terms: ['figuras', 'figures'], label: 'LEGO® Figuras', url: '/products/seleccion-figuras-lego' },
    { terms: ['ruedas', 'wheels'], label: 'LEGO® Ruedas', url: '/products/seleccion-ruedas-lego' },
    { terms: ['cristales', 'crystals'], label: 'LEGO® Cristales', url: '/products/seleccion-cristales-lego' }
  ];
  const searchTimers = new WeakMap();
  const normalize = (value) => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  const distance = (a, b) => {
    const row = Array.from({ length: b.length + 1 }, (_, index) => index);
    for (let i = 1; i <= a.length; i += 1) {
      let previous = row[0]; row[0] = i;
      for (let j = 1; j <= b.length; j += 1) {
        const current = row[j];
        row[j] = Math.min(row[j] + 1, row[j - 1] + 1, previous + (a[i - 1] === b[j - 1] ? 0 : 1));
        previous = current;
      }
    }
    return row[b.length];
  };

  const enhanceTypedSearch = (input) => {
    window.clearTimeout(searchTimers.get(input));
    const timer = window.setTimeout(() => {
      const value = normalize(input.value);
      document.querySelectorAll('.rog-search-empty--client').forEach((notice) => notice.remove());
      if (value.length < 3) return;
      const nearest = searchTerms.flatMap((item) => item.terms.map((term) => ({ item, term, score: distance(value, term) }))).sort((a, b) => a.score - b.score)[0];
      window.setTimeout(() => {
        const listbox = input.closest('predictive-search-component')?.querySelector('[role="listbox"]');
        if (!listbox || listbox.querySelector('.rog-search-empty')) return;
        const text = normalize(listbox.textContent || '');
        if (!text.includes('tambien podria interesarte') && !text.includes('you may also like') && !text.includes('vous aimerez peut etre') && !text.includes('tambem poderas gostar')) return;
        const language = (document.documentElement.lang || 'es').slice(0, 2);
        const messages = {
          es: ['No hemos encontrado una coincidencia exacta.', 'Prueba con otra palabra o explora estas recomendaciones.', '¿Quizá buscabas'],
          en: ['We could not find an exact match.', 'Try another term or explore these recommendations.', 'Perhaps you meant'],
          fr: ['Nous n’avons trouvé aucune correspondance exacte.', 'Essayez un autre terme ou découvrez ces recommandations.', 'Vous cherchiez peut-être'],
          pt: ['Não encontrámos uma correspondência exata.', 'Experimenta outro termo ou explora estas recomendações.', 'Talvez quisesses procurar']
        };
        const copy = messages[language] || messages.es;
        const notice = document.createElement('div');
        notice.className = 'rog-search-empty rog-search-empty--client';
        notice.innerHTML = `<p class="rog-search-empty__title"></p><p></p>`;
        notice.children[0].textContent = copy[0]; notice.children[1].textContent = copy[1];
        const container = listbox.querySelector('.predictive-search-results__inner');
        container?.prepend(notice);
        if (nearest && nearest.score === 1) {
          const correction = document.createElement('a');
          correction.className = 'rog-search-correction';
          correction.href = nearest.item.url;
          correction.textContent = `${copy[2]} ${nearest.item.label}? →`;
          notice.insertAdjacentElement('afterend', correction);
        }
      }, 700);
    }, 420);
    searchTimers.set(input, timer);
  };

  formatWholeMoney();

  document.addEventListener('click', (event) => {
    const themeSummary = event.target.closest('.rog-theme-family > summary');
    if (themeSummary && !themeSummary.parentElement.open) {
      themeSummary.closest('.rog-theme-families')?.querySelectorAll('.rog-theme-family[open]').forEach((details) => details.removeAttribute('open'));
    }
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const target = new URL(link.href, window.location.href);
    if (target.origin === window.location.origin && target.pathname !== window.location.pathname) saveScroll();
  }, { capture: true });
  document.addEventListener('input', (event) => {
    if (event.target.matches('input[type="search"]')) enhanceTypedSearch(event.target);
  }, { capture: true });

  window.addEventListener('pagehide', saveScroll);
  window.addEventListener('pageshow', () => {
    queueInteractionRestore();
    restoreScroll();
  });
  window.addEventListener('popstate', queueInteractionRestore);
  window.addEventListener('resume', queueInteractionRestore);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') queueInteractionRestore();
  });

  document.addEventListener('DOMContentLoaded', () => {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    queueInteractionRestore();
    restoreScroll();
    cleanProductCopy();
    formatWholeMoney();
    improveSearch();
    enhanceContactForms();
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length)) {
        cleanProductCopy();
        formatWholeMoney();
        improveSearch();
        enhanceContactForms();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
